import { HttpHeaders } from '@angular/common/http';

export const DEFAULT_HEADERS = new HttpHeaders({
      'Content-Type': 'application/json',
    //   'Access-Control-Allow-Origin': '*',
    //   'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
});
